module.exports = __webpack_public_path__ + "img/wechat1.f1c51dc9.png";